import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import NavBar from "../components/geriactive/NavBar";
import TimeTracking from "../components/geriactive/utils/analytics/TimeTracking";
import { CONTENT_ID, scrollToContent } from "../utils/layout";

function PageContainer(props) {
  const location = useLocation();

  useEffect(() => {
    // Games render their board immediately on navigation, so the route change is
    // the right moment to scroll. Embeds (videos, presentations, lessons) appear
    // asynchronously and scroll themselves once their content is on screen.
    if (location.pathname.startsWith("/games/")) {
      scrollToContent();
    }
  }, [location.pathname]);

  return (
    <>
      <TimeTracking />
      <NavBar />
      <div id={CONTENT_ID}>
        <Outlet />
      </div>
    </>
  );
}

export default PageContainer;
